import { useState, useEffect } from "react";
import {
  Stack,
  TextField,
  InputLabel,
  FormHelperText,
  Typography
} from "@mui/material";

export const Text = ({ label, value, onValidate, subtext, onChange, inputProps }) => {
  const [text, setText] = useState(value);
  const [error, setError] = useState("");

  useEffect(() => {
    setText(value);
  }, [value]);

  const update = (value) => {
    try {
      setError("");
      setText(value);
      onValidate && onValidate(value);
      onChange(value);
    } catch (e) {
      setError(e.message);
    }
  }

  return (
    <Stack direction="column" spacing={1}>
      <InputLabel sx={{fontWeight: 'bold', color: '#000'}}>{label}</InputLabel>
      {subtext && <Typography variant="body2" color="#999" sx={{marginTop: '5px!important'}}>{subtext}</Typography>}
      <TextField
        type="text"
        variant="outlined"
        value={text}
        error={!!error}
        onChange={(e) => update(e.target.value)}
        {...inputProps}
      />
      {error && (
        <FormHelperText error={true}>Error: {error}</FormHelperText>
      )}
    </Stack>
  )
}